var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRight42X(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 13,
    viewBox: "0 0 14 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.4317 5.37809C11.6595 5.16656 11.6595 4.82359 11.4317 4.61206C11.2039 4.40053 10.8345 4.40053 10.6067 4.61206L6.65279 8.28357C6.42499 8.4951 6.42499 8.83807 6.65279 9.0496C6.8806 9.26114 7.24994 9.26114 7.47775 9.0496L11.4317 5.37809Z",
    fill: "#131635"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.52341 9.0496C6.75122 9.26113 7.12056 9.26113 7.34837 9.0496C7.57618 8.83806 7.57618 8.4951 7.34837 8.28357L3.39444 4.61206C3.16663 4.40052 2.79728 4.40052 2.56948 4.61206C2.34167 4.82359 2.34167 5.16655 2.56948 5.37809L6.52341 9.0496Z",
    fill: "#131635"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRight42X);
export default __webpack_public_path__ + "static/media/right-4@2x.bfa3e2d3ecea52bd3af702c0c96d2c2d.svg";
export { ForwardRef as ReactComponent };